<template>
    <div class="cz2__steps-options__shared">
        <step-header />

        <selection-card-list class="cz2__steps-options__list-wrapper">
            <selection-card
                v-for="component in availableComponents"
                :key="component.code"
                :code="component.code"
                :image="component.custom['fun-image-v2'] || component.custom['fun-image'] || component.custom.image"
                :name="component.custom['fun-title']"
                :component="component"
                @select="select(component)"
                :isSelected="isSelected(component)"
                :isOutOfStock="isOutOfStock(component)"
            />
        </selection-card-list>
    </div>
</template>

<script>
    import SelectionCard from './ui/SelectionCard.vue';
    import SelectionCardList from './ui/SelectionCardList.vue';
    import StepHeader from './ui/StepHeader.vue';
    import Swiper from './ui/Swiper.vue';

    export default {
        components: {
            SelectionCard,
            SelectionCardList,
            StepHeader,
            Swiper,
        },

        computed: {
            viewController() {
                return this.$store.state.customizer.viewController;
            },

            currentGroup() {
                return this.$store.state.customizer.currentGroup;
            },

            editPlacement() {
                if (this.viewController == null) {
                    return null;
                }

                if (this.currentGroup.placements == null || this.currentGroup.placements.length === 0) {
                    return null;
                }

                return this.currentGroup.placements[0];
            },

            availableComponents() {
                const placement = this.editPlacement;
                if (placement == null) {
                    return [];
                }

                const components = placement.components.filter((c) => !c.placeholder && this.viewController.isAllowed(c));
                const inStockComponents = components.filter((c) => !this.isOutOfStock(c));
                const oosComponents = components.filter((c) => this.isOutOfStock(c));

                return inStockComponents.concat(oosComponents);
            },

            selectedComponent() {
                const placement = this.editPlacement;
                if (placement == null) {
                    return null;
                }

                const selected = this.viewController.selectedAtPlacement(placement.code);

                return selected && !selected.placeholder ? selected : null;
            },

            isFilled() {
                return this.selectedComponent != null;
            },

            previousGroup() {
                return this.$store.getters.previousGroup;
            },

            nextGroup() {
                return this.$store.getters.nextGroup;
            },
        },

        mounted() {
            this.updateNavigation();
        },

        methods: {
            isSelected(component) {
                return this.selectedComponent && this.selectedComponent.code === component.code;
            },

            isOutOfStock(component) {
                return this.viewController.isAllowed(component) && !this.viewController.isAvailable(component);
            },

            select(component) {
                const placement = this.editPlacement;

                if (placement != null) {
                    this.$store.dispatch('updateComponent', {
                        placement: placement.code,
                        code: component.code,
                    }).then(() => {
                        // Is this still available?
                        // The head may have already been disabled by a follow up component.
                        // This happens when selecting Buzz Cut -> then backtracking and switching lashes again.
                        if (!this.viewController.isAvailable(component)) {
                            // Whelp if not... try to find an acceptable head?
                            // Pick a new head while preserving lashes state.
                            const hasLashes = component.tags?.includes('lashes');

                            // eslint-disable-next-line no-restricted-syntax
                            for (const c of placement.components) {
                                if (!this.viewController.isAvailable(c)) {
                                    // eslint-disable-next-line no-continue
                                    continue;
                                }

                                const lashes = c.tags?.includes('lashes');

                                if (lashes === hasLashes) {
                                    if (this.viewController.updateComponent(placement.code, c.code)) {
                                        break;
                                    }
                                }
                            }
                        }
                    });
                }

                this.updateNavigation();
            },

            updateNavigation() {
                this.$emit('updateNavigation', {
                    hasBack: !!this.previousGroup,
                    canGoBack: !!this.previousGroup,
                    hasNext: !!this.nextGroup,
                    // Must be filled.
                    canGoNext: this.isFilled,
                });
            },
        },
    };
</script>
